import {inject, Injectable} from "@angular/core"
import {GenerateThumbnailsDataObjectInput} from "@cm/job-nodes"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {mutateThrowingErrors} from "@common/helpers/api/mutate"
import {UploadProcessingDataObjectGQL, UploadProcessingProcessUploadGQL} from "@common/services/upload/upload-processing.generated"

@Injectable({providedIn: "root"})
export class UploadProcessingService {
    readonly processUploadGql = inject(UploadProcessingProcessUploadGQL)
    readonly uploadProcessingDataObject = inject(UploadProcessingDataObjectGQL)

    public async createUploadProcessingJob(dataObjectId: string, options?: GenerateThumbnailsDataObjectInput["options"]) {
        const {dataObject} = await fetchThrowingErrors(this.uploadProcessingDataObject)({id: dataObjectId})
        // don't create another job if we are already processing this data object
        if (dataObject.metadataProcessingJob && dataObject.thumbnailProcessingJob) {
            return dataObject.metadataProcessingJob
        }
        return mutateThrowingErrors(this.processUploadGql)({
            dataObjectId,
            generateTiles: options?.generateTiles,
        }).then(({processUpload}) => processUpload)
    }
}
